"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  padding: 0;
  margin-top: -16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  z-index: 2;
`;
exports.ArrowWrapper = styled_components_1.default.div `
  ${({ theme, foward, lightMode, disabled }) => `
    display: flex;
    align-items: center;
    svg {
      cursor: pointer;
      font-size: 24px;
      ${lightMode
    ? disabled
        ? `color: ${theme.colors.action.navigation.alt.disabled};`
        : `color: ${theme.colors.action.navigation.alt.static};`
    : disabled
        ? `color: ${theme.colors.action.navigation.standard.disabled};`
        : `color: ${theme.colors.action.navigation.standard.static};`}
    }

    ${foward
    ? `
        margin-left: ${theme.spaces.sp2};
        transform: rotate(180deg);`
    : ''}
  `}
`;
